export const ExportEndpoints = {
  file: (attachmentId: string) => `/export/${attachmentId}/file`,
};
